<div class="iss-not-authorized-page-up"></div>
<div class="iss-not-authorized-page-center">
  <div class="iss-not-authorized-page-title">No access...</div>
  <div class="iss-not-authorized-page-msg">It seems you are not authorized to display this page.</div>
  <button tuiButton (click)="logout()">Logout</button>
</div>
<div class="iss-not-authorized-page-down"></div>
